import {createStore} from 'vuex';
import app from '@/store/app';
import bank from '@/store/bank';
import invoices from '@/store/invoices';
import user from '@/store/user';
import billing from '@/store/billing';
import subscription from '@/store/subscription';
import company from '@/store/company';
import provider from '@/store/provider';
import oauth from '@/store/oauth';
import tracking from '@/store/tracking';
import vat from '@/store/vat';
import partner from '@/store/partner';
import translations from '@/store/translations';
import treasuryInvestment from '@/store/treasuryInvestment';
import analytics from '@/store/analytics';

export default createStore({
  modules: {
    app,
    bank,
    billing,
    company,
    provider,
    invoices,
    subscription,
    user,
    oauth,
    tracking,
    vat,
    partner,
    translations,
    treasuryInvestment,
    analytics,
  },
});
